
import React from 'react';
import './BottomNav.css';
import { useApp } from '../../context/AppContext';
import { haptic } from '../../utils/haptic';

interface BottomNavProps {
  cartCount: number;
  unreadMessages: number;
}

const BottomNav: React.FC<BottomNavProps> = ({ cartCount, unreadMessages }) => {
  const { activeTab, setActiveTab, viewMode } = useApp();

  const tabs = [
    {
      id: 'home',
      label: 'Home',
      icon: (active: boolean) => (
        <svg viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={active ? 0 : 2}>
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          {!active && <polyline points="9 22 9 12 15 12 15 22"/>}
        </svg>
      )
    },
    {
      id: 'shop',
      label: 'Shop',
      icon: (active: boolean) => (
        <svg viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={active ? 0 : 2}>
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6" stroke={active ? 'white' : 'currentColor'} strokeWidth="2"/>
          <path d="M16 10a4 4 0 01-8 0" stroke={active ? 'white' : 'currentColor'} strokeWidth="2" fill="none"/>
        </svg>
      )
    },
    {
      id: 'cart',
      label: 'Cart',
      badge: cartCount,
      icon: (active: boolean) => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.5 : 2}>
          <circle cx="9" cy="21" r="1" fill={active ? 'currentColor' : 'none'}/>
          <circle cx="20" cy="21" r="1" fill={active ? 'currentColor' : 'none'}/>
          <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
        </svg>
      )
    },
    {
      id: 'messages',
      label: 'Messages',
      badge: unreadMessages,
      icon: (active: boolean) => (
        <svg viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={active ? 0 : 2}>
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
        </svg>
      )
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: (active: boolean) => (
        <svg viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={active ? 0 : 2}>
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      )
    }
  ];

  return (
    <nav className={`bottom-nav ${viewMode === 'light' ? 'light' : 'dark'}`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => {
            if (activeTab !== tab.id) haptic('tap');
            setActiveTab(tab.id);
          }}
        >
          <div className="nav-icon-wrapper">
            <div className="nav-icon">
              {tab.icon(activeTab === tab.id)}
            </div>
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className="nav-badge">{tab.badge > 9 ? '9+' : tab.badge}</span>
            )}
          </div>
          <span className="nav-label">{tab.label}</span>
          {activeTab === tab.id && <div className="nav-indicator" />}
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
